/**
 * 统一输出 Java 响应结构（严格）：
 * {
 *   code: number,
 *   msg: string,
 *   data: object
 * }
 *
 * PHP 输入（严格）：
 * {
 *   error: 0|1,
 *   errortip: string,
 *   result: object|string,
 *   ...others
 * }
 *
 * 转换规则：
 * 1) code = error===0 ? 200 : 500
 * 2) msg = errortip
 * 3) data：先展开 result（对象），再平移 result 同级字段
 *    - result 为对象：data <- { ...result, ...others(without error/errortip/result) }
 *    - result 为字符串：data <- { value: string, ...others }
 *
 * Java 输入（严格）：
 * {
 *   code: number,
 *   msg: string,
 *   data: object
 * }
 * 若 data 非对象，强制包裹为 { value: data }，以保证 data 始终为对象。
 */
function hasOwn(obj, key) {
  return Object.prototype.hasOwnProperty.call(obj, key);
}

function isPlainObject(v) {
  return v != null && typeof v === "object" && !Array.isArray(v);
}

function toIntCode(v) {
  var n = Number(v);
  return Number.isNaN(n) ? 500 : n;
}

function normalizeJavaData(data) {
  if (data == null) {
    return {};
  }
  if (isPlainObject(data)) {
    return Object.assign({}, data);
  }
  return { value: data };
}

function pickBusinessFields(payload) {
  var out = {};
  Object.keys(payload).forEach(function (key) {
    if (
      key === "code" ||
      key === "msg" ||
      key === "data" ||
      key === "result" ||
      key === "error" ||
      key === "errortip"
    ) {
      return;
    }
    out[key] = payload[key];
  });
  return out;
}

function normalizeJavaEnvelope(payload) {
  var code = toIntCode(payload.code);
  var msg = payload.msg != null ? String(payload.msg) : "";
  var data = normalizeJavaData(payload.data);
  return {
    code: code,
    msg: msg,
    data: data,
  };
}

function normalizePhpEnvelope(payload) {
  var ok = payload.error == 0 || payload.error === "0";
  var code = ok ? 200 : 500;
  var msg = payload.errortip != null ? String(payload.errortip) : payload.msg != null ? String(payload.msg) : "";
  var result = payload.result;
  var others = pickBusinessFields(payload);

  var data;
  if (isPlainObject(result)) {
    data = Object.assign({}, result, others);
  } else if (typeof result === "string") {
    data = Object.assign({ value: result }, others);
  } else if (result == null) {
    data = Object.assign({}, others);
  } else {
    data = Object.assign({ value: result }, others);
  }

  return {
    code: code,
    msg: msg,
    data: data,
  };
}

/**
 * 历史命名保留：flattenJavaEnvelope
 * 现在语义为“归一化为 Java 响应”
 */
export function flattenJavaEnvelope(payload) {
  if (payload == null || typeof payload !== "object" || Array.isArray(payload)) {
    return payload;
  }
  if (hasOwn(payload, "code")) {
    return normalizeJavaEnvelope(payload);
  }
  if (hasOwn(payload, "error") || hasOwn(payload, "errortip")) {
    return normalizePhpEnvelope(payload);
  }
  return payload;
}

export function isApiSuccess(payload) {
  return payload && payload.code === 200;
}

export function getApiData(payload) {
  return payload && payload.data;
}

/** 登录失效等：tokeninc 在 data 内 */
export function getTokenincHolder(envelope) {
  const body = getApiData(envelope);
  if (!body || typeof body !== "object") return null;
  if (body.tokeninc != null) return body;
  return null;
}
